//approved files set to determine regular models vs MISC models on Asset files tab.
export const approvedFilesSet = new Set(['glb', 'usdz']);
//constants
export const artifactStatusMap = {
	needs_review: {
		label: 'Needs Review',
		value: 'needs_review',
	},
	approved: {
		label: 'Approved',
		value: 'approved',
	},
	rejected: {
		label: 'Rejected',
		value: 'rejected',
	},
	building: {
		label: 'Building',
		value: 'building',
	},
	build_failed: {
		label: 'Build Failed',
		value: 'build_failed',
	},
	public: {
		label: 'Public',
		value: 'public',
	},
	published: {
		label: 'Published',
		value: 'published',
	},
	live: {
		label: 'Live',
		value: 'live',
	},
	deactivate: {
		label: 'Deactivate',
		value: 'deactivate',
	}
};

export const manageAssetFileApprovalViewerToolTip = 'view this generated file in the Approval Viewer';
// artifact size limit in bytes (should be 5 MB or less)
export const buildArtifactSizeLimit = 5242880;

// Below set of status can be selected by the user.
export const userSelectableArtifactStatus = new Set([
	artifactStatusMap.approved.value,
	artifactStatusMap.rejected.value,
]);
// limit source file name to 100 characters.
export const sourceFileNameLenLimit = 100;
export const fileNameLenWarningMsg = `file name can't be greater than ${sourceFileNameLenLimit} characters`;
// Row limit for the CSV file upload.
export const csvFileRowLimit = 500;
export const pubArtifactsWarnMsg =
	'This change will impact the published artifacts of the primary source model down stream. Do you want to proceed?';
export const pubArtifactsStatusWarnMsg =
	'This change will directly replace the Live artifact(s) on Lowes.com. Do you want to proceed? ';
